// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import './css/site.css'

Vue.config.productionTip = false

/* 全局前置守卫：带 role 元信息的路由需要登录态 */
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.role) {
    if (localStorage.getItem('user')) {
      next()
    } else {
      next('/login.html')
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
